import "../MainBox/MainBox.css";
import AccordUS from "../MainBox/US/accord-US";
import AccordDK from "../MainBox/DK/accord-DK";
import { apiHelper } from "../lib/ApiHelper";
import { useEffect, useState} from "react";
import SpecFormDK from "../MainBox/DK/SpecForm-DK";
import MetadataUS from "../MainBox/US/Metadata-US";
import MetadataDK from "../MainBox/DK/Metadata-DK";
import DisabledAccordUS from "./DummyAccordian/Disabled-Accord-US"
import DisabledAccordDK from "./DummyAccordian/Dummy-Accord-DK";
import DummyMeta from "../MainBox/Dummy-Meta";
import DummyAccord from "../MainBox/Dummy-Accord";
import { useFetcher } from "react-router-dom";


export default function MainBox (props){
    const [isLoading, setIsLoading] = useState(true);
    const [onchangeNote, setChangeNote] = useState(false);
    const [fullList, setFullList] = useState([]);
    const [titleList, setTitleList] = useState([]);
    const [metaData, setMetaData] = useState(null);
    const [reportData, setReportData] = useState([]);
    
    const [isShrunk, setShrunk] = useState(false);
    const [isEditable, setIsEditable] = useState(true);
    
    const setOnChangeNote = () => {
        setChangeNote(prev => !prev);
    }
    const fetchTitleList = async () => {
        try {
            let data = await apiHelper.getStatus();
            if (data)
                data = await data.sort((a, b) => {
                    if (a.status < b.status) return -1;
                    if (a.status > b.status) return 1;
                });
            setTitleList(data.filter(item => item.manualStatus.toLowerCase() == 'y'));
            setFullList(data);

        } catch (error) { console.log(error); }
    }

    const handleScroll = () => {
        try {
            if (window) {
                setShrunk((window.scrollY > 0));
            }
        } catch ({ name, message }) {
            console.warn('handleScroll error', name, message);
        }
    };
    const componentLoad = () => {
        try {
         
            if (window) {
                window.addEventListener('scroll', handleScroll, { passive: true });
            }
        }
        catch ({ name, message }) {
            console.warn('handleScroll error', name, message);
        }
    }


    useEffect(() => {
        componentLoad();

        return () => {
            try {
                if (window) {
                    window.removeEventListener('scroll', handleScroll);
                }
            }
            catch ({ name, message }) {
                console.warn('removeEventListener error', name, message);
            }
        }
    }, []);

    useEffect(() => {
        if (props.reloadData) {
            const payload = props.reloadData;
            setMetaData(prev => ({ ...prev, statusId: payload?.statusId, expirationDate: (payload?.statusId == 23) ? payload?.ExpirationDate : null, agendaDate: ( payload?.statusId == 16) ? payload?.AgendaDate : null }));
        }
    }, [props.reloadData])

    useEffect(() => {
        props.setReloadData(null);
    }, [metaData])
    const fetchMetaDataV2 = async () => {
        try {
            props.setIsMetaLoading(true);
            const result = await apiHelper.inventoryPostCall("getISBNMetaDataV2", { isbnList: [props.ISBNId], UPN: props?.upn });
            if (result != undefined && result != null) {
                if (result?.metadata && result?.metadata.length > 0) {
                  //  result.metadata[0].access = 'm';
                    setMetaData(result?.metadata[0]);
                    setIsEditable(result?.metadata[0].audience === props?.audience && result?.metadata[0].access === 'm');
                } else {
                    setMetaData(null);

                }
                if (result?.reports && result?.reports.length > 0) {
                    setReportData(result?.reports);
                }
            }
           
        } catch (error) {
            console.error(error);
        } finally {
            props.setIsMetaLoading(false);
        }
        
    }

    useEffect(() => {

        if (!isLoading) {
            if (props.ISBNId != '') {
                fetchMetaDataV2();
                fetchTitleList();
            } else {
                setMetaData(null);
            }
          
        } else {
            setIsLoading(false);
        }
    }, [props.ISBNId])


    return (
        <>  
            <div className="landing-main container-fluid">
                <div className="Accord centred container-fluid">
                    {metaData && metaData?.audience === "DK" ?
                        <>
                            <div className={`sticky-data container-fluid ${props?.audience == 'DK' ? 'dk-top' : 'us-top'}`}>

                                <MetadataDK metaData={metaData} isShrunk={isShrunk} isbns={props.BiISBNs}
                                    src={props.ISBNId != "" ? `${'https://images.randomhouse.com/cover/' + props.ISBNId}` : ''} upn={props.upn} fetchMetaData={fetchMetaDataV2}  isMetaLoading={props.isMetaLoading} setMetaData={setMetaData} titleList={titleList} fullList={fullList} isEditable={isEditable}></MetadataDK>


                            </div>
                            {
                                metaData?.access === 'd' ? <DisabledAccordDK/>:
                                <AccordDK
                                setOnChangeNote={setOnChangeNote}
                                userInitials={props.userInitials}
                                onchangeNote={onchangeNote}
                                accessTokens={props.accessTokens}
                                BiToken={props.BiToken}
                                ISBNs={props.BiISB}
                                ISBNId={props.ISBNId}
                                metaData={props.ISBNId != "" ? metaData : null}
                                upn={props.upn}
                                reportData={reportData}
                                isMetaLoading={props.isMetaLoading}
                                isEditable={isEditable}
                                DKAccordSetting={props.DKAccordSetting}
                                setDKAccordSetting={props.setDKAccordSetting}
                                isbnData={props.isbnData}
                                setIsbnData={props.setIsbnData}
                            ></AccordDK>}
                        </> : (metaData && metaData?.audience === "US" ? <>
                            <div className={`${props.audience == 'DK' ? 'dk-top sticky-data container-fluid' : 'us-top sticky-data container-fluid'}`}>

                                <MetadataUS metaData={metaData} isShrunk={isShrunk} isbns={props.BiISBNs}
                                    src={props.ISBNId != "" ? `${'https://images.randomhouse.com/cover/' + props.ISBNId}` : ''} upn={props.upn} fetchMetaData={fetchMetaDataV2} audience={props.audience} isMetaLoading={props.isMetaLoading} setMetaData={setMetaData} titleList={titleList} fullList={fullList} isEditable={isEditable}></MetadataUS>


                            </div>
                            {metaData?.access === 'd' ? <DisabledAccordUS /> : <AccordUS
                                accessTokens={props.accessTokens}
                                BiToken={props.BiToken}
                                ISBNs={props.BiISB}
                                ISBNId={props.ISBNId}
                                metaData={props.ISBNId != "" ? metaData : null}
                                upn={props.upn}
                                reportData={reportData}
                                audience={props.audience}
                                isEditable={isEditable}
                                isMetaLoading={props.isMetaLoading}
                                USAccordSetting={props.USAccordSetting}
                                setUSAccordSetting={props.setUSAccordSetting}
                                isbnData={props.isbnData}
                                setIsbnData={props.setIsbnData}
                            ></AccordUS>}
                        </>
                            :
                            <>
                              
                                <div className={`${props.audience == 'DK' ? 'dk-top sticky-data container-fluid' : 'us-top sticky-data container-fluid'}`}>
                                    <DummyMeta src={props.ISBNId != "" ? `${'https://images.randomhouse.com/cover/' + props.ISBNId}` : ''} isMetaLoading={props.isMetaLoading} ISBNId={props.ISBNId}></DummyMeta>
                                </div>
                                      <DummyAccord></DummyAccord>
                                
                        </>)}
         
                </div>
            </div>
        </>
    )
}